import { useLocation, useNavigate } from "react-router-dom";
import Tabs from "@/components/Tabs";
import { TabItem } from "./types";

interface JobPostIndexTabLayoutProps {
  children: React.ReactNode;
  jobPostId: string;
  tabs: TabItem[];
}

export default function JobPostIndexTabLayout({ children, tabs }: JobPostIndexTabLayoutProps) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="flex w-full flex-col">
      <div className="border-b border-sys-surface-variant">
        <Tabs
          tabItems={tabs.map(({ label, path }) => ({
            label,
            onClick: () => navigate(path),
            active: location.pathname.endsWith(path.split("/").pop() || "")
          }))}
        />
      </div>
      {children}
    </div>
  );
}
